(function() {
    'use strict';

    angular.module('user')
        .controller('DiscountGroupListController', DiscountGroupListController);

    DiscountGroupListController.$inject = ['$state', 'datatableDefaultPageSizeValueConst', 'discountGroupPermissionsConst', 'discountGroupMessagesConst', 'discountGroupDataSrvc', 'checkSearchSrvc', 'notificationSrvc', 'modalSrvc', 'filterQuerySrvc', 'lodashService'];

    function DiscountGroupListController($state, datatableDefaultPageSizeValueConst, discountGroupPermissionsConst, discountGroupMessagesConst, discountGroupDataSrvc, checkSearchSrvc, notificationSrvc, modalSrvc, filterQuerySrvc, lodashService) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.discountGroupRows = [];
        self.discountGroupCols = [{
            title: 'ID',
            value: 'pk',
            type: 'number',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Obrót netto',
            value: 'net_turnover',
            type: 'number',
            searchable: false,
            orderable: true
        }, {
            title: 'Liczba zamówień',
            value: 'orders_count',
            type: 'number',
            searchable: false,
            orderable: true
        }, {
            title: 'Liczba dni',
            value: 'days_count',
            type: 'number',
            searchable: false,
            orderable: true
        }, {
            title: 'Procent',
            value: 'value',
            type: 'number',
            searchable: false,
            orderable: true
        }];

        self.modelPermissions = discountGroupPermissionsConst;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.searchQuery = {
            pk: null,
            name: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getDiscountGroups();
        }

        function getDiscountGroups(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    pk: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    ordering: self.searchQuery.ordering
                };
            }
            return discountGroupDataSrvc.list(
                filterObj
            ).$promise.then(
                function(response) {
                    self.discountGroupRows = response.results;
                    self.pageOpts.count = response.count;
                    return response;
                },
                function(response) {
                    if (response.status === 404 && filterObj.page !== 1) {
                        checkSearchSrvc.recall(filterObj, getDiscountGroups);
                    }
                }
            ).finally(
                function(response) {
                    self.loading = false;
                    return response;
                }
            );
        }

        function onCreate() {
            $state.go('layout.discountGroup.create');
        }

        function onEdit(row) {
            $state.go('layout.discountGroup.update', { pk: row.pk });
        }

        function onDelete(row) {
            return modalSrvc.confirmRemove(
                row.name,
                function() {
                    discountGroupDataSrvc.remove({
                        pk: row.pk
                    }).$promise.then(
                        function (response) {
                            notificationSrvc.notification("success", discountGroupMessagesConst.delete);
                            lodashService.remove(self.discountGroupRows, { pk: row.pk });
                            return response;
                        },
                        function (response) {
                            notificationSrvc.notification("error", discountGroupMessagesConst.error);
                            return response;
                        }
                    );
                }
            );
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getDiscountGroups();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getDiscountGroups();
        }
    }
})();
